import React from 'react';
import './spinner.css';

export const spinner = <div className="loader">Loading...</div>;
